import { render, staticRenderFns } from "./DevEnvRibbon.vue?vue&type=template&id=f0d47baa&scoped=true&"
import script from "./DevEnvRibbon.vue?vue&type=script&lang=js&"
export * from "./DevEnvRibbon.vue?vue&type=script&lang=js&"
import style0 from "./DevEnvRibbon.vue?vue&type=style&index=0&id=f0d47baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d47baa",
  null
  
)

export default component.exports